module.exports = __webpack_public_path__ + "img/backup.dbd80cb.svg";